module.exports = __webpack_public_path__ + "c93640350d65341dde9bff0f4e830e13.ico";